<template>
  <svg width="100%" height="100%" viewBox="0 0 28 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14 24H26M18 4.72579L22 8.58063M20 2.79836C20.5304 2.28718 21.2499 2 22 2C22.3714 2 22.7392 2.0705 23.0824 2.20749C23.4256 2.34447 23.7374 2.54525 24 2.79836C24.2626 3.05148 24.471 3.35196 24.6131 3.68267C24.7553 4.01338 24.8284 4.36783 24.8284 4.72579C24.8284 5.08374 24.7553 5.43819 24.6131 5.7689C24.471 6.09961 24.2626 6.40009 24 6.65321L7.33333 22.7151L2 24L3.33333 18.8602L20 2.79836Z"
      stroke="currentColor"
      stroke-width="2.33333"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
